// extracted by mini-css-extract-plugin
export var dataCell = "_ld-2";
export var dataRow = "_ld-0";
export var headerRow = "_ld-1";